import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { finalize } from "rxjs/operators";
import { StringHelper } from "../../utilities/contracts/string-helper";
import * as i0 from "@angular/core";
import * as i1 from "../../core/environment.tokens";
import * as i2 from "@angular/common/http";
export class SocialMediaService {
    constructor(baseApiUrl, http) {
        this.baseApiUrl = baseApiUrl;
        this.http = http;
        this.linkedin = new BehaviorSubject("");
        this.pLinkedinUrl$ = this.linkedin.asObservable();
        this.facebook = new BehaviorSubject("");
        this.pFacebookUrl$ = this.facebook.asObservable();
        this.twitter = new BehaviorSubject("");
        this.pTwitterUrl$ = this.twitter.asObservable();
        this.loading = false;
    }
    get linkedinUrl$() {
        this.lazyLoadSocialMediaUrls();
        return this.pLinkedinUrl$;
    }
    get facebookUrl$() {
        this.lazyLoadSocialMediaUrls();
        return this.pFacebookUrl$;
    }
    get twitterUrl$() {
        this.lazyLoadSocialMediaUrls();
        return this.pTwitterUrl$;
    }
    lazyLoadSocialMediaUrls() {
        const hasLinkedin = StringHelper.isAvailable(this.linkedin.getValue());
        const hasFacebook = StringHelper.isAvailable(this.facebook.getValue());
        const hasTwitter = StringHelper.isAvailable(this.twitter.getValue());
        if (!this.loading && (!hasLinkedin || !hasFacebook || !hasTwitter)) {
            this.loadSocialMediaUrls();
        }
    }
    loadSocialMediaUrls() {
        this.loading = true;
        const url = `${this.baseApiUrl}navigation/socialmedia`;
        this.http
            .get(url)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response) => {
            this.linkedin.next(response.Linkedin);
            this.facebook.next(response.Facebook);
            this.twitter.next(response.Twitter);
        });
    }
}
SocialMediaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SocialMediaService_Factory() { return new SocialMediaService(i0.ɵɵinject(i1.BASE_API_URL), i0.ɵɵinject(i2.HttpClient)); }, token: SocialMediaService, providedIn: "root" });
